import React from "react";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import {Green, Red, Yellow} from "../InstallationCheck";
import {Failure, Passed, Warning} from "./HistoricalInstallCheck";

function TestResultSymbol ({ result }) {

    const getSymbol = () => {
        if (result === Failure) {
            return (
                <HighlightOffOutlinedIcon style={{color: Red, fontSize: 40}}/>
            );
        } else if (result === Warning) {
            return (
                <CheckCircleOutlineOutlinedIcon style={{color: Yellow, fontSize: 40}}/>
            );
        } else if (result === Passed) {
            return (
                <CheckCircleOutlineOutlinedIcon style={{color: Green, fontSize: 40}}/>
            );
        }
    };

    return (
        getSymbol()
    );
}

export default TestResultSymbol;